import React, {
  useRef, useEffect,
} from 'react';
import styled from 'styled-components';
import merge from 'lodash/merge';
import { useSelector } from 'react-redux';
import { selectLocale } from 'models/localization';
import { selectDesktopBanners } from 'models/virtual_event';
import FooterV2 from 'components/footer_v2';
import Routes from 'Routes';
import GenericBanner from './GenericBanner';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

const PageContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  transform-origin: top left;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  perspective: ${({ perspective }) => perspective}px;
`;

const StyledBackgroundImage = styled.img`
  max-width: 100vw;
  width: 100%;
  height: auto;
  position: relative;
`;

const BackgroundVideo = styled.video`
  position: ${({ isAbsolute }) => (isAbsolute ? 'absolute' : 'relative')};
  left: 0;
  top: 0;
  max-width: 100vw;
  width: 100%;
  height: auto;
`;

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
`;

const GenericDesktopLobbyView = () => {
  const locale = useSelector(selectLocale);
  const perspective = useSelector((state) => state.eventConfigs.lobby.perspective);
  const {
    videoPreviewSrc, videoSrc, videoConfig,
  } = useSelector((state) => state.eventConfigs.lobby);
  const bannerAssets = useSelector(selectDesktopBanners);

  const videoRef = useRef();

  useEffect(() => {
    if (!videoRef.current) return;

    const mergedVideoConfig = merge(
      {
        autoplay: true, loop: true, muted: true, playsinline: true,
      },
      videoConfig || {},
    );

    Object.assign(videoRef.current, mergedVideoConfig);
  }, [videoConfig]);

  return (
    <RootContainer>
      <PageContainer perspective={perspective}>
        {videoPreviewSrc && <StyledBackgroundImage src={videoPreviewSrc} key={videoPreviewSrc} />}
        {
          videoSrc && (
            <BackgroundVideo ref={videoRef} isAbsolute={!!videoPreviewSrc} key={videoSrc}>
              <source src={videoSrc} type="video/mp4" />
            </BackgroundVideo>
          )
        }
        {bannerAssets?.map((banner, index) => (
          <GenericBanner
            key={`${index}${banner.name}`}
            banner={banner}
            locale={locale}
          />
        ))}
      </PageContainer>
      <FooterWrapper>
        <FooterV2 hashState={Routes.lobby} />
      </FooterWrapper>
    </RootContainer>
  );
};

export default GenericDesktopLobbyView;
